export enum SideNavActionsIds {
	ORDONNANCE = "ORDONNANCE",
	ORDONNANCE_DE_SOIN = "ORDONNANCE_DE_SOIN",
	ORDONNANCE_RAPIDE = "ORDONNANCE_RAPIDE",
	ORDONNANCE_BSI = "ORDONNANCE_BSI",
	ORDONNANCE_PRESCRIPTION_IDEL = "ORDONNANCE_PRESCRIPTION_IDEL",
	ORDONNANCE_PRESCRIPTION_IPA = "ORDONNANCE_PRESCRIPTION_IPA",
	ORDONNANCE_MONOGRAPHIE = "ORDONNANCE_MONOGRAPHIE",
	PAIEMENT = "PAIEMENT",
	PAIEMENT_FACTURER = "PAIEMENT_FACTURER",
	PAIEMENT_TELETRANSMETTRE = "PAIEMENT_TELETRANSMETTRE",
	PAIEMENT_SAISIR_UN_PAIEMENT = "PAIEMENT_SAISIR_UN_PAIEMENT",
	PAIEMENT_REDEVANCE = "PAIEMENT_REDEVANCE",
	PAIEMENT_CHIFFRE_AFFAIRES = "PAIEMENT_CHIFFRE_AFFAIRES",
	PATIENTELE = "PATIENTELE",
	PATIENTELE_PATIENT = "PATIENTELE_PATIENT",
	PATIENTELE_RENDEZ_VOUS = "PATIENTELE_RENDEZ_VOUS",
	PATIENTELE_LECTURE_CV = "PATIENTELE_LECTURE_CV",
	COORDINATION = "COORDINATION",
	COORDINATION_CONSTANTE = "COORDINATION_CONSTANTE",
	COORDINATION_TRAITEMENT = "COORDINATION_TRAITEMENT",
	COORDINATION_TRANSMISSION = "COORDINATION_TRANSMISSION",
	COORDINATION_DIAGRAMME_DE_SOIN = "COORDINATION_DIAGRAMME_DE_SOIN",
	/**
	 * Ne pas supprimer, à décommenter quand on implémentera la fonctionnalité
	 */
	// COORDINATION_SUIVI_DE_PLAIE = "COORDINATION_SUIVI_DE_PLAIE",
	// TELESANTE = "TELESANTE",
	// TELESANTE_TELESOIN = "TELESANTE_TELESOIN",
	// TELESANTE_TELEEXPERTISE = "TELESANTE_TELEEXPERTISE",
	// TELESANTE_TELECONSULTATION = "TELESANTE_TELECONSULTATION",
}
